import React from 'react';
import { Link } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem, Loading,
	Module,
	ModuleBody,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';

import { useCurrentEd, useTemplate } from '../../hooks/preview';
import { Preview } from './Preview';
import { formatDate } from '../../utils';


export function PagePreview() {
	const template = useTemplate();
	const ed = useCurrentEd();
	const docId = ed?.docSlug;

	return (
		<div>
			<SecondaryNavigation>
				<Breadcrumb>
					<BreadcrumbItem>
						<Link to="/">
							<BreadcrumbHome/>
						</Link>
					</BreadcrumbItem>
					{docId && <>
						<BreadcrumbItem>
							<Link to={`/${docId}`}>
								{formatDate(docId)}
							</Link>
						</BreadcrumbItem>
						<BreadcrumbItem disableLink> Preview</BreadcrumbItem>
					</>
					}
				</Breadcrumb>
				<SecondaryNavigationTitle>Document preview for edition: {ed?.name || '...'}</SecondaryNavigationTitle>
			</SecondaryNavigation>

			<Wrapper background="lighter" pageWidth="lg" spacing="md">
				<Module>
					<ModuleBody>
						{ed ?
							<Preview template={template} edition={ed}/> :
							<Loading withOverlay={false} active small/>
						}
					</ModuleBody>
				</Module>
			</Wrapper>
		</div>
	);
}